module.exports = __webpack_public_path__ + "static/media/logo.b33be728.jpg";